import React, { useState, useCallback, useMemo } from "react";
import { Card, CardBody, Alert } from "reactstrap";
import ListEmptyComponent from "../../Layout/LoggedInLayout/ListEmptyComponent";
import InfiniteScroll from "react-infinite-scroll-component";
import { ModalGateway, Modal } from "react-images";
import { Link } from "react-router-dom";
import { IonGrid, IonRow, IonCol } from "@ionic/react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import ImageDownloader from "./URLDownload";
import { useAtom } from "jotai";
import { PhotoGalleryAtom, activeChildDetail } from "../../AtomStore/store";
import { useRequestProcessor } from "../../requestProcessor";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { fetchPhotos } from "../../QueryFunctions/queryfunction";
import SpinnerLoading from "../../Components/utils/SpinnerLoading";
import { Facebook, StyledPhotosDiv, Twitter } from "./styles";
import { getAppConstants } from "../../AtomStore/ServiceAtoms";
import ImageComponent from "../../Layout/LoggedInLayout/ImageComponent";
import moment from "moment";

const PhotoGallery = () => {
  const { useQueryWrapper } = useRequestProcessor();
  const [hasMore, setHasMore] = useState(true);
  const [startIndex, setStartIndex] = useState(0);
  const constants = getAppConstants();

  const [activeChild] = useAtom(activeChildDetail);
  const [photos, setPhotos] = useAtom(PhotoGalleryAtom);

  const LIMIT = 50;
  const FACEBOOK_APPID = "1663256590659601";

  useMemo(() => {
    console.log(
      `[Photo Gallery] Fetching Photo Gallery for user: ${activeChild?.id}`
    );
  }, [activeChild]);

  const { isLoading } = useQueryWrapper(
    ["photos", activeChild?.id, startIndex],
    () => fetchPhotos(startIndex, photos, setHasMore),
    {
      onSuccess: (data) => {
        setPhotos((prev) => (startIndex === 0 ? data : [...prev, ...data]));
      },
      refetchOnWindowFocus: false,
    }
  );

  const arrowStyles = {
    position: "absolute",
    zIndex: 2,
    top: "calc(45% - 15px)",
    width: 30,
    height: 50,
    cursor: "pointer",
    border: 0,
    background: "none",
  };

  const next = () => setStartIndex((prev) => prev + LIMIT + 1);

  const shareImageFacebook = (image) => {
    const caption = `${activeChild.name} ${activeChild.last_name} in ${activeChild["room.name"]} at ${activeChild["center.name"]}`;
    let url = `https://www.facebook.com/dialog/feed?display=popup&app_id=${FACEBOOK_APPID}&link=${image}&title=${caption}`;
    window.open(url);
  };

  const shareImageTwitter = (image) => {
    const caption = `${activeChild.name} ${activeChild.last_name} in ${activeChild["room.name"]} at ${activeChild["center.name"]}`;
    const url = `https://twitter.com/intent/tweet?text=${caption}&url=${image}`;
    window.open(url);
  };

  // Lightbox state
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((e, index) => {
    e.preventDefault();
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const Footer = (image) => (
    <>
      <Link
        className="bg-white rounded-full p-1 h-8 w-8 flex justify-center items-center border-2 shadow-9"
        to="#"
        onClick={() => shareImageFacebook(image)}
      >
        <Facebook />
      </Link>
      <Link
        className="bg-white rounded-full p-1 h-8 w-8 flex justify-center items-center border-2 shadow-9"
        to="#"
        onClick={() => shareImageTwitter(image)}
      >
        <Twitter />
      </Link>
    </>
  );

  return (
    <Card className="border-0 shadow card-timeline" style={{ padding: 0 }}>
      {isLoading && <SpinnerLoading />}
      <CardBody
        className="p-0"
        id="photo-scroll"
        style={{ height: "90vh", overflow: "auto" }}
      >
        {Array.isArray(photos) && photos.length > 0 ? (
          <InfiniteScroll
            dataLength={photos.length}
            next={next}
            hasMore={hasMore}
            scrollableTarget="photo-scroll"
            loader={<SpinnerLoading />}
          >
            <Alert className="m-2" color="warning">
              {constants?.ArchiveMessage}
            </Alert>
            <IonGrid className="[@media(max-width:768px)and(min-height:580px)]:pb-16">
              <IonRow className="border-collapse">
                {photos.map((photo, index) => (
                  <IonCol
                    key={index}
                    size="6"
                    sizeSm="6"
                    sizeMd="6"
                    sizeLg="4"
                    sizeXl="3"
                    className="flex justify-center items-center p-1"
                  >
                    <div className="relative w-full h-[180px] sm:h-[200px] md:h-[220px] lg:h-[240px]">
                      <ImageComponent
                        src={photo.src}
                        onClick={(e) => openLightbox(e, index)}
                        profile={false}
                        className="w-full h-full rounded-sm object-cover"
                        variant="grid"
                      />
                      {photo.date && (
                        <div className="absolute bottom-0 w-full bg-black bg-opacity-50 text-white text-xs sm:text-sm text-center py-1 rounded-b-sm">
                          {moment(photo.date).format("DD MMM YYYY")}
                        </div>
                      )}
                    </div>
                  </IonCol>
                ))}
              </IonRow>
            </IonGrid>
          </InfiniteScroll>
        ) : (
          <div className="p-4">
            <ListEmptyComponent
              heading={isLoading ? "Loading..." : "No Data Found"}
            />
          </div>
        )}

        <ModalGateway>
          {viewerIsOpen && (
            <Modal onClose={closeLightbox}>
              <Carousel
                className="flex justify-center"
                renderArrowPrev={(onClickHandler, hasPrev, label) =>
                  hasPrev && (
                    <button
                      type="button"
                      onClick={onClickHandler}
                      title={label}
                      className="carousel-arrow"
                      style={{ ...arrowStyles, left: 5 }}
                    >
                      <FaAngleLeft style={{ color: "#4267B2", fontSize: 35 }} />
                    </button>
                  )
                }
                renderArrowNext={(onClickHandler, hasNext, label) =>
                  hasNext && (
                    <button
                      type="button"
                      onClick={onClickHandler}
                      className="carousel-arrow"
                      title={label}
                      style={{ ...arrowStyles, right: 22 }}
                    >
                      <FaAngleRight
                        style={{ color: "#4267B2", fontSize: 35 }}
                      />
                    </button>
                  )
                }
                width="700px"
                selectedItem={currentImage}
                showStatus={false}
                showIndicators={false}
                showArrows
                showThumbs={false}
                swipeable
              >
                {photos.map((photo, index) => (
                  <StyledPhotosDiv key={index}>
                    <ImageDownloader
                      imageUrl={photo.src}
                      component={Footer(photo.src)}
                      closeLightbox={closeLightbox}
                    />
                  </StyledPhotosDiv>
                ))}
              </Carousel>
            </Modal>
          )}
        </ModalGateway>
      </CardBody>
    </Card>
  );
};

export default PhotoGallery;
